let Test = require('@/mixins/Forms/2022/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            construction_inspection: {
                name: `A2. Construction Inspection (NA7.6.5.1)`,
                rows: {
                    row_1: {
                        id: `1`,
                        type: `Boolean`,
                        question: `The demand responsive controls for controlled receptacles are shown on plan documents and are installed.`,
                        code_reference: `NA7.6.5.1(c)`,
                        answer: false,
                    },
                    row_2:{
                        id:`2`,
                        type:`Boolean`,
                        question:`The demand responsive control is setup to communicate in one of the following communication protocols: Wi-Fi, ZigBee, BACnet, Ethernet, or other wired or wireless bi-directional communication pathway. The demand responsive controls is setup to communicate for the functional testing of NA7.6.5.2.`,
                        code_reference: `NA7.6.5.1`,
                        answer:false
                    },
                    row_3:{
                        id:`3`,
                        type:`Boolean`,
                        question:`Controlled receptacles or circuits have permanent or durable markings to differentiate them from uncontrolled receptacles or circuits`,
                        code_reference: `NA7.6.5.1(d), §130.5(d)3`,
                        answer:false
                    },
                    row_4:{
                        id:`4`,
                        type:`Boolean`,
                        question:`Controlled receptacles are controlled by an automatic shut off control.`,
                        code_reference: `NA7.6.5.1(e), Section 130.5(d)1, Section 160.6(d)1`,
                        answer:false
                    }
                },
                result: false,
            },
            functional_test: {
                name: `B. Functional Testing (NA7.6.5.2.3)`,
                rows: {
                    row_1: {
                        id: `1`,
                        type: `Text`,
                        text: `On test.`,
                        code_reference:`NA7.6.5.2.3, On test`,
                    },
                    row_2: {
                        id: `1.1`,
                        type: `Text`,
                        text: `Trigger the shut off control to turn the demand responsive controlled receptacle on, or if the receptacle has a manual control turn the receptacle on.`,
                        code_reference:`NA7.6.5.2.3, On test (1)`,
                    },
                    row_3: {
                        id: `1.2`,
                        type: `Boolean`,
                        question: `The controlled outlet has full voltage (125 V) present.`,
                        code_reference:`NA7.6.5.2.3, On test (2)`,
                        answer:false
                    },
                    row_4: {
                        id: `1.3`,
                        type: `Text`,
                        text: `Simulate a demand response condition using the demand responsive control.`,
                        code_reference:`NA7.6.5.2.3, On test (3)`,
                    },
                    row_5: {
                        id: `1.4`,
                        type: `Boolean`,
                        question: `The controlled outlet has zero voltage (0 V) present (deenergized)`,
                        code_reference:`NA7.6.5.2.3, On test (4)`,
                        answer:false
                    },
                    row_6: {
                        id: `1.5`,
                        type: `Boolean`,
                        question: `The controlled receptacle cannot be overridden to turn on by the automatic shut off controls or any manual control.`,
                        code_reference:`NA7.6.5.2.3, On test (5)`,
                        answer:false
                    },
                    row_7: {
                        id: `1.6`,
                        type: `Text`,
                        text: `Simulate a normal condition (non-demand response condition).`,
                        code_reference:'NA7.6.5.2.3, On test (6)',
                    },
                    row_8: {
                        id: `1.7`,
                        type: `Boolean`,
                        question: `The controlled outlet has full voltage (125 V) present.`,
                        code_reference:`NA7.6.5.2.3, On test (7)`,
                        answer:false
                    },
                    row_9: {
                        id: `2`,
                        type: `Text`,
                        text: `Off test.`,
                        code_reference:`NA7.6.5.2.3, Off test`,
                    },
                    row_10: {
                        id: `2.1`,
                        type: `Text`,
                        text: `Trigger the automatic shut off control to turn the demand responsive controlled receptacle off, or if the receptacle has a manual control turn the receptacle off.`,
                        code_reference:`NA7.6.5.2.3, Off test (1)`,
                    },
                    row_11: {
                        id: `2.2`,
                        type: `Boolean`,
                        question: `The controlled outlet has zero voltage (0 V) present (deenergized).`,
                        code_reference:`NA7.6.5.2.3, Off test (2)`,
                        answer:false
                    },
                    row_12: {
                        id: `2.3`,
                        type: `Text`,
                        text: `Simulate a demand response condition using the demand responsive control.`,
                        code_reference:`NA7.6.5.2.3, Off test (3)`,
                    },
                    row_13: {
                        id: `2.4`,
                        type: `Boolean`,
                        question: `The controlled outlet has zero voltage (0 V) is present (deenergized).`,
                        code_reference:`NA7.6.5.2.3, Off test (4)`,
                        answer:false
                    },
                    row_14: {
                        id: `2.5`,
                        type: `Boolean`,
                        question: `The demand responsive controlled receptacle cannot be overridden to turn on by automatic shut off controls or any manual control.`,
                        code_reference: `NA7.6.5.2.3, Off test (5)`,
                        answer:false
                    },
                    row_15: {
                        id: `2.6`,
                        type: `Text`,
                        text: `Simulate a normal condition (non-demand response condition).`,
                        code_reference:`NA7.6.5.2.3, Off test (6)`,
                    },
                    row_16: {
                        id: `2.7`,
                        type: `Boolean`,
                        question: `The controlled outlet has zero voltage (0 V) present (deenergized).`,
                        code_reference:`NA7.6.5.2.3, Off test (7)`,
                        answer:false
                    },
                },
                result: false,
                comments: '',
            },
        }
    },

    mounted() {

    },

    methods: {

        functionalTestEvaluation() {
            this.form.functional_test.result = true;
            _.each(this.form.functional_test.rows, (row, i) => {
                if (row.question) {
                    if (!row.answer) {
                        this.form.functional_test.result = false;
                    }
                }
            })
        },

        loadFormData() {
            if (!this.data) return;

            _.each(this.data.construction_inspection.rows, (question, i) => {
                this.form.construction_inspection.rows[i].answer = question.answer;
            })

            _.each(this.data.functional_test.rows, (row,i)=>{
                if (!this.isText(this.form.functional_test.rows[i])) {
                    this.form.functional_test.rows[i].answer = row.answer;
                }
            })

            this.form.comments = this.comments;
        },

    },

    computed: {

    }

}
